import request from '@/http/request'

export const getAsnStatsTable = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getAsnStatsTableV2`, { params, noSpin: true })
}
export const getAsnCaseTrend = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getAsnCaseTrendV2`, { params, noSpin: true })
}
export const getReturnGradePie = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getReturnGradePieV2`, { params, noSpin: true })
}
export const getAsnWhStatusWaterfall = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getAsnWhStatusWaterfall`, {
    params,
    noSpin: true
  })
}
export const getAsnLeadTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getAsnLeadTime`, { params, noSpin: true })
}
export const getAsnAbnormalTreemap = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/getAsnAbnormalTreemap`, {
    params,
    noSpin: true
  })
}
